/**
 * Confirmation copy shown before deleting a time-off block.
 *
 * Removing a block does NOT auto-restore the appointments it sent to triage
 * when it was created — that is a deliberate, locked scheduling decision
 * (2026-05-07): orphaned appointments are reclaimed or reassigned, never
 * silently put back. The earlier copy only said they "will NOT be
 * auto-restored", which reads as if the appointments are lost. This names
 * the recovery path so the consequence is non-silent AND actionable: the
 * appointments are still in the triage queue and can be picked up there.
 */
export function timeOffDeleteWarning(mode: 'self' | 'manager'): string {
  const recover =
    mode === 'manager'
      ? 'They stay in the triage queue — reassign them from Appointments → Orphans.'
      : 'They stay in the triage queue — you or another agent can reclaim them from Appointments → Orphans.';
  return (
    'Remove this day-off entry? Any appointments it moved to triage will NOT ' +
    `come back automatically. ${recover}`
  );
}
